<template>  
  <div>
    <div class="mcontent">    
      <q-checkbox v-model="$store.state.showTracks" :label="$t('global.ShowTracks')" />
      <q-tree  
        color="primary"
        :nodes="trackingGroups" 
        :expanded.sync="propsExpanded"
        node-key="ID"
        :ticked.sync="ticked"
        :tick-strategy="tickStrategy" 
        @lazy-load="onLazyLoad"
        :selected.sync="selected"
      >
      </q-tree>
    </div>
  </div>
</template>

<script>
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'DeviceTree',
  data () {
    return {
      form: {
        SessionId: null,
      },
      selected: null,
      ticked: [],
      tickStrategy: 'leaf',
      propsExpanded: [],
      trackingGroups: [],
      
    }
  },
  methods: {
    onLazyLoad ({ node, key, done, fail }) {
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "DeviceTreeDevice"
      this.form.TrackingGroupID = key
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            if(response.data.length > 0)
              done(response.data)
            else
              fail()  
          }
          else{
              this.$q.notify('Something Wrong.')
              fail()  
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        fail()  
        console.log(e);
      })
    },
    loadTrackingGroups(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "DeviceTreeTrackingGroup"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.trackingGroups = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    }
  },
  watch: {
    ticked: function (newValue, oldValue) {  
      if(newValue.length != oldValue.length){
        if(newValue.length > oldValue.length){
          console.log('add element')
          var tempSelect = newValue.filter(x => !oldValue.includes(x));
          console.log('tempSelect: ' + tempSelect)
          eventBus.$emit('addLiveTrack', tempSelect)
        }  
        else{   
          console.log('remove element')
          var tempSelect = oldValue.filter(x => !newValue.includes(x));  
          console.log('tempSelect: ' + tempSelect)
          eventBus.$emit('removeLiveTrack', tempSelect)
        }
      }
    },

    selected: function(newValue, oldValue){
      if(this.$store.state.session.Admin == true){
        if(newValue != null){
            eventBus.$emit('UnitCommandDialog', newValue)
        }
      }
    }
    
  },
  created () {
    this.loadTrackingGroups()
  },
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>

<style scoped>
.mcontent{
  padding: 10px;
  padding-top: 0px;
}

</style>
